export const eventMarker = `<svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.0231 25.8758C9.0231 21.1839 10.1781 16.86 12.4882 12.9041C14.7983 8.94813 17.9631 5.82019 21.9827 3.52024C26.0022 1.22028 30.3452 0.047301 35.0116 0.00130186C39.6779 -0.0446973 44.0209 1.12828 48.0404 3.52024C52.06 5.91219 55.2248 9.04013 57.5349 12.9041C59.845 16.768 61 21.0919 61 25.8758C61 27.8538 60.5149 30.1537 59.5446 32.7757C58.5744 35.3976 57.3501 38.0426 55.8716 40.7105C54.3932 43.3785 52.7068 46.0924 50.8125 48.8524C48.9183 51.6123 47.0702 54.1883 45.2683 56.5802C43.4665 58.9722 41.7801 61.0882 40.2092 62.9281C38.6384 64.7681 37.3909 66.2631 36.4669 67.413L35.0116 69C34.6419 68.632 34.1568 68.08 33.5562 67.344C32.9556 66.6081 31.7312 65.1591 29.8832 62.9971C28.0351 60.8352 26.3256 58.6732 24.7548 56.5112C23.1839 54.3493 21.359 51.8193 19.2799 48.9214C17.2008 46.0234 15.4913 43.2635 14.1515 40.6415C12.8116 38.0196 11.5873 35.4206 10.4785 32.8447C9.36961 30.2687 8.8845 27.9458 9.0231 25.8758ZM17.6859 25.8758C17.6859 30.6597 19.3723 34.7306 22.745 38.0886C26.1177 41.4465 30.2066 43.1255 35.0116 43.1255C39.8165 43.1255 43.9054 41.4465 47.2781 38.0886C50.6508 34.7306 52.3372 30.6597 52.3372 25.8758C52.3372 21.0919 50.6508 17.044 47.2781 13.732C43.9054 10.4201 39.8165 8.71814 35.0116 8.62614C30.2066 8.53414 26.1177 10.2361 22.745 13.732C19.3723 17.228 17.6859 21.2759 17.6859 25.8758Z" fill="#FF6000"/>
<circle cx="35" cy="26" r="18" fill="white"/>
<path d="M36.8824 26.3671C37.6899 26.3671 38.4645 25.6333 38.4274 24.7672C38.3903 23.9011 37.7476 23.1673 36.8824 23.1673C36.0749 23.1673 35.3003 23.9011 35.3374 24.7672C35.3745 25.6333 36.0172 26.3671 36.8824 26.3671Z" fill="#212121"/>
<path d="M32.4075 28.2859C33.2151 28.2859 33.9896 27.552 33.9525 26.686C33.9155 25.8199 33.2727 25.0861 32.4075 25.0861C31.6 25.0861 30.8255 25.8199 30.8626 26.686C30.8996 27.552 31.5424 28.2859 32.4075 28.2859Z" fill="#212121"/>
<path d="M30.0698 24.0941C30.0772 24.0963 30.0848 24.0978 30.0924 24.0986C30.42 24.1325 30.9104 24.0725 31.3229 23.7769C31.743 23.4759 32.065 22.9427 32.065 22.0699C32.065 21.547 32.065 21.1484 32.0819 20.83C32.0989 20.5115 32.1323 20.2834 32.1949 20.0997C32.3166 19.7429 32.556 19.527 33.1062 19.1472C33.6513 18.7709 34.1356 18.4999 34.7022 18.4096C35.2675 18.3196 35.9301 18.4073 36.832 18.7808C37.1274 18.9032 37.3785 18.9973 37.592 19.0773C37.6969 19.1166 37.7928 19.1526 37.8804 19.1868C38.1497 19.2919 38.346 19.3827 38.5217 19.5128C38.8736 19.7733 39.1633 20.2053 39.7362 21.2915C39.8362 21.4811 39.9733 21.6721 40.1724 21.7927C40.3992 21.9299 40.6983 22.0522 41.0115 22.0532C41.3311 22.0542 41.6581 21.9285 41.9239 21.5844C42.3029 21.0939 42.4154 20.7259 42.3628 20.3446C42.3375 20.1612 42.275 19.9825 42.1996 19.7964C42.1687 19.7202 42.1366 19.6446 42.1033 19.5665C42.0523 19.4466 41.9987 19.3206 41.9429 19.1763C41.7509 18.6791 41.3259 18.0958 40.8868 17.6172C40.666 17.3764 40.4383 17.1586 40.2295 16.9881C40.0237 16.82 39.8262 16.6895 39.6669 16.6345C39.605 16.6131 39.4977 16.5599 39.3503 16.4868C38.289 15.9605 35.148 14.4028 31.8778 16.2628C31.0504 16.6646 29.5481 18.0081 29.1564 20.4584L29.1548 20.4682C29.0287 21.2572 28.8916 22.1145 29.0787 22.9278C29.1938 23.4284 29.476 23.9184 30.0698 24.0941ZM27.3012 29.7243C26.7732 29.9977 26.6176 30.4909 26.6253 30.9536C26.6371 31.6673 26.9466 32.3563 27.3889 32.8859C28.0009 33.6187 28.9609 34.2347 29.4958 34.5121C31.4796 35.6524 33.4496 35.7361 34.7417 35.5459C35.4586 35.4403 36.1918 35.3103 36.8903 35.0766C38.6587 34.4848 39.407 32.8423 39.5687 31.9592C40.1384 29.7924 39.8344 28.6661 39.2823 28.1519C39.0203 27.9077 38.682 27.8326 38.3524 27.8672C38.0236 27.9018 37.6945 28.0458 37.4331 28.2534C37.0896 28.5264 36.9937 28.849 36.945 29.2492C36.9304 29.3687 36.9199 29.4938 36.9087 29.6276C36.8822 29.9434 36.8517 30.3079 36.7541 30.7627C36.5732 31.6053 35.7663 32.0969 34.9658 32.3505C34.2885 32.5651 33.5861 32.7453 32.9072 32.6774C32.02 32.5886 30.8529 32.1357 30.0132 31.2661C29.7233 30.9659 29.4903 30.6953 29.2881 30.4605C29.269 30.4382 29.2501 30.4163 29.2315 30.3947C29.0185 30.1477 28.8339 29.9374 28.6523 29.7869C28.4676 29.6339 28.2769 29.5349 28.0502 29.5209C27.8267 29.5071 27.5857 29.577 27.3012 29.7243Z" fill="#212121"/>
</svg>`;

export const darkThemeStyles = [
	{
		elementType: "geometry",
		stylers: [
			{
				color: "#212121"
			}
		]
	},
	{
		elementType: "labels.icon",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#757575"
			}
		]
	},
	{
		elementType: "labels.text.stroke",
		stylers: [
			{
				color: "#212121"
			}
		]
	},
	{
		featureType: "administrative",
		elementType: "geometry",
		stylers: [
			{
				color: "#757575"
			}
		]
	},
	{
		featureType: "administrative.country",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#9e9e9e"
			}
		]
	},
	{
		featureType: "administrative.land_parcel",
		stylers: [
			{
				visibility: "off"
			}
		]
	},
	{
		featureType: "administrative.locality",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#bdbdbd"
			}
		]
	},
	{
		featureType: "poi",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#757575"
			}
		]
	},
	{
		featureType: "poi.park",
		elementType: "geometry",
		stylers: [
			{
				color: "#181818"
			}
		]
	},
	{
		featureType: "poi.park",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#616161"
			}
		]
	},
	{
		featureType: "poi.park",
		elementType: "labels.text.stroke",
		stylers: [
			{
				color: "#1b1b1b"
			}
		]
	},
	{
		featureType: "road",
		elementType: "geometry.fill",
		stylers: [
			{
				color: "#2c2c2c"
			}
		]
	},
	{
		featureType: "road",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#8a8a8a"
			}
		]
	},
	{
		featureType: "road.arterial",
		elementType: "geometry",
		stylers: [
			{
				color: "#373737"
			}
		]
	},
	{
		featureType: "road.highway",
		elementType: "geometry",
		stylers: [
			{
				color: "#3c3c3c"
			}
		]
	},
	{
		featureType: "road.highway.controlled_access",
		elementType: "geometry",
		stylers: [
			{
				color: "#4e4e4e"
			}
		]
	},
	{
		featureType: "road.local",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#616161"
			}
		]
	},
	{
		featureType: "transit",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#757575"
			}
		]
	},
	{
		featureType: "water",
		elementType: "geometry",
		stylers: [
			{
				color: "#000000"
			}
		]
	},
	{
		featureType: "water",
		elementType: "labels.text.fill",
		stylers: [
			{
				color: "#3d3d3d"
			}
		]
	}
];
